import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesDataTableOfContent } from './TableOfContent.proptypes';

import Text from '../../../../ui/Atoms/Text';

import * as S from './TableOfContent.styles';

export const TableOfContentSlice = ({ slice }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const list = slice.items || [];
  const { table_of_content_description: description } = data || '';

  if (list.length <= 1) {
    Sentry.captureMessage(
      'Error: missing required data in TableOfContent slice'
    );
    return null;
  }

  return (
    <S.TableOfContent>
      {description && <S.Title>{description}</S.Title>}
      {list.map((part, index) => {
        const {
          content_part_name: contentPartName,
          content_part_url: { url: contentPartUrl } = {},
        } = part || '';

        if (!contentPartName || !contentPartUrl) {
          return null;
        }

        const listedPart = `<li><a href="${contentPartUrl}" rel="noopener">${contentPartName}</a></li>`;

        return <Text key={`${part}-${index}`}>{listedPart}</Text>;
      })}
    </S.TableOfContent>
  );
};

TableOfContentSlice.propTypes = {
  /**
   * Content of the TableOfContent slice.
   */
  slice: PropTypes.shape(propTypesDataTableOfContent),
};
